import React from 'react';
import { Play, ArrowRight } from 'lucide-react';
import { ABOUT_PAGE } from '../mock';
import Reveal from './Reveal';

const HerMusic = ({ onPlay }) => {
  const { music } = ABOUT_PAGE;
  const first = music.tracks[0];

  return (
    <section className="bg-cream py-16 md:py-20">
      <div className="mx-auto grid max-w-[1400px] items-center gap-12 px-6 md:px-10 lg:grid-cols-12 lg:gap-14">
        {/* Intro */}
        <div className="lg:col-span-4">
          <Reveal>
            <p className="mb-6 text-[10px] uppercase tracking-[0.5em] text-gold-dark">
              {music.label}
            </p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-5xl font-light tracking-[0.05em] text-ink md:text-6xl">
              {music.title}
            </h2>
            <p className="mt-1 font-serif text-2xl font-light italic tracking-[0.08em] text-ink/70">
              {music.artistLine}
            </p>
          </Reveal>
          <Reveal delay={220}>
            <p className="mt-6 max-w-xs text-[12px] leading-relaxed text-ink/60">
              {music.text}
            </p>
          </Reveal>
          <Reveal delay={320}>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <button
                data-testid="her-music-listen-btn"
                onClick={() => onPlay && onPlay(first)}
                className="group inline-flex items-center gap-3 bg-gold px-7 py-3.5 text-[11px] tracking-[0.25em] text-ink transition-colors duration-300 hover:bg-gold-dark hover:text-cream"
              >
                LISTEN NOW
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
              <button
                data-testid="her-music-watch-btn"
                onClick={() => onPlay && onPlay(first)}
                className="group inline-flex items-center gap-3 border border-ink/40 px-7 py-3.5 text-[11px] tracking-[0.25em] text-ink transition-colors duration-300 hover:border-gold-dark hover:text-gold-dark"
              >
                WATCH VIDEO
                <Play size={11} fill="currentColor" />
              </button>
            </div>
          </Reveal>
        </div>

        {/* Album cover */}
        <Reveal delay={200} className="lg:col-span-3">
          <div className="relative mx-auto aspect-square w-full max-w-[340px] overflow-hidden shadow-[0_30px_60px_-20px_rgba(12,11,10,0.45)]">
            <img
              src={music.cover}
              alt={`${music.title} by KHM — album cover`}
              loading="lazy"
              className="h-full w-full object-cover"
            />
          </div>
        </Reveal>

        {/* Tracklist */}
        <Reveal delay={300} className="lg:col-span-5">
          <div>
            {music.tracks.map((track, i) => (
              <button
                key={track.id}
                data-testid={`her-music-track-${track.id}`}
                onClick={() => onPlay && onPlay(track)}
                className="group flex w-full items-center gap-5 border-b border-ink/10 py-4 text-left transition-colors duration-300 hover:bg-ink/[0.03]"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ink/25 text-ink transition-colors duration-300 group-hover:border-gold-dark group-hover:bg-gold group-hover:text-ink">
                  <Play size={11} fill="currentColor" />
                </span>
                <span className="w-5 font-serif text-base italic text-ink/40">{i + 1}</span>
                <span className="flex-1">
                  <span className="block text-base tracking-[0.12em] text-ink transition-colors duration-300 group-hover:text-gold-dark">
                    {track.title}
                  </span>
                  <span className="block text-[10px] tracking-[0.08em] text-ink/50">
                    {track.artist}
                  </span>
                </span>
                <span className="text-[10px] tracking-[0.15em] text-ink/45">{track.duration}</span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HerMusic;
